import { useState } from "react"
export const useLoader = (callback) =>{
    const [isLoading, setIsLoading] = useState(false);
    const [error,setError] = useState('');
    const fetching = async () => {
        try {
            setIsLoading(true)
            await callback()
        } catch (error) {
            setError(error.message)
            console.log('Ошибка из useLoader');
            
            console.log(error);
            
        } finally {
            setIsLoading(false)
        }
    }
    return[fetching, isLoading, error]
}